import { LucideIcon } from 'lucide-react';
import React from 'react';
import clsx from 'clsx';

interface IJobNavigationTabItem {
  name: string | React.ReactNode;
  onPress: () => void;
  icon: LucideIcon;
  active: boolean;
  className?: string;
}

export default function JobNavigationTabItem({
  name,
  onPress,
  icon: Icon,
  active = false,
  className,
}: IJobNavigationTabItem) {
  return (
    <div
      onClick={onPress}
      aria-current={active ? 'page' : undefined}
      className={clsx(
        'relative inline-flex flex-col md:flex-row items-center justify-center gap-2 cursor-pointer text-sm whitespace-nowrap transition-colors',
        'px-3 py-4 md:px-4 md:py-4',
        active
          ? 'bg-primary-50 font-semibold border-y-2 border-primary md:border-0 md:bg-transparent'
          : 'text-muted-foreground hover:text-foreground border-y-2 border-transparent md:border-0',
        className
      )}
    >
      <Icon
        size={16}
        className={clsx(
          'shrink-0',
          name === 'Бүх ажлын зар' && 'md:hidden',
          active ? 'text-primary' : 'text-[#717680]'
        )}
      />

      <span
        className={clsx(
          'hidden md:inline text-[14px]',
          active ? 'text-[#181D27]' : 'text-[#717680]'
        )}
      >
        {name}
      </span>

      <div
        className={clsx(
          'absolute bottom-0 left-0 right-0 h-1 rounded-t-full bg-primary transition-all duration-300 ease-in-out z-20 hidden md:block',
          active ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
        )}
      />
    </div>
  );
}
